import React, { useState } from "react";
import { Typography, Card } from "antd";
import { FinancialChart } from "./FinancialChart";

const { Text } = Typography;

type ChartType = "area" | "bar" | "line";
type FilterType = "quarterly" | "annually";

interface ChartCardProps {
  graphData: any;
  loading: boolean;
  baseCurrency: string;
  defaultChartType?: ChartType;
  defaultFilter?: FilterType;
  onFilterChange?: (filter: FilterType) => void;
  showFilterToggle?: boolean;
}

export const ChartCard: React.FC<ChartCardProps> = ({
  graphData,
  loading,
  baseCurrency,
  defaultChartType = "area",
  defaultFilter = "annually",
  onFilterChange,
}) => {
  const [chartType, setChartType] = useState<ChartType>(defaultChartType);
  const [filter, setFilter] = useState<FilterType>(defaultFilter);

  const handleFilterChange = (val: FilterType) => {
    setFilter(val);
    onFilterChange?.(val);
  };

  return (
    <Card className="vi-beg-chartcard-inner w-full">
      {/* Chart */}
      <FinancialChart
        graphData={graphData}
        baseCurrency={baseCurrency}
        loading={loading}
        absoluteChartType={chartType}
        percentageChartType={chartType}
        daysChartType={chartType}
        multiplesChartType={chartType}
      />
    </Card>
  );
};
